import React from 'react';
import { message, Modal, Button, Icon } from 'antd';
import common from "@/assets/common.js";
import QR from "qrcode.react";
import './bindmodal.css';

class BindModal extends React.Component {
  constructor(){
    super();
    this.state = {
      status: "bind",
      qrStatus: "",
      openId : window.info.openId,
      time: new Date().getTime(),
    }
  }
  componentWillReceiveProps(props){
    if(props.modalType === "bind"){
      this.getBindQr();
      this.setState({ status : "bind", qrStatus : "" });
      this.setState({ openId : window.info.openId })
    }
  }
  getBindQr = () => {
    var postData = {};
    postData["_url"] = "api/qrcode/get-qrcode-login-url";
    postData["_method"] = "GET";
    postData["qrCodeType"] = 'BIND';
    common.request(postData, this, function(obj, result){
      if(result.status === "success"){
        obj.setState({
          loginCode : result.data.loginCode,
          loginQr : result.data.authUrl,
          qrStatus : "WAIT"
        });
        window.inter = window.setInterval(function(){
          obj.getStatus();
        }, 1000);
      } else {
        message.warning(result.message);
      }
    },function(obj, data){
    });
  }
  getStatus = () => {
    const loginCode = this.state.loginCode;
    var postData = {};
    postData["_url"] = "api/qrcode/get-qrcode-login-status";
    postData["loginCode"] = loginCode;
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, result){
      const qrCodeStatus = result.qrCodeStatus;
      if(result.status === "success"){
        const data = result.data;
        if(data.status){
          window.clearInterval(window.inter);
          obj.setState({ qrStatus : qrCodeStatus });
          if(window.info.openId){
            obj.unBind(data);
          } else {
            obj.bind(data);
          }
        }
      } else {
        window.clearInterval(window.inter);
        message.warning(result.message);
        obj.getStatus();
      }
    });
  }
  bind = (data) => {
    var postData = data;
    postData["_url"] = "admin/qr/code/bind";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      obj.setState({status: 'success'})
      window.clearInterval(window.inter);
      window.info = data.data;
      common.setCookie("info", JSON.stringify(data.data))
    })
  }
  unBind = (data) => {
    var postData = data;
    postData["_url"] = "admin/qr/code/unbind";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      window.info.openId = "";
      common.setCookie("info", JSON.stringify(window.info))
      obj.setState({status: 'success'})
      window.clearInterval(window.inter);
      // obj.logout();
    });
  }
  logout = () => {
    var postData = {};
    postData["_url"] = "admin/logout";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      window.info = {};
      window.setTimeout(function(){
        window.location.href = "#/login";
      }, 1000);
    })
  }
  closeModal = () => {
    window.clearInterval(window.inter);
    this.props.showModal("");
    window.setTimeout((() => {
      this.setState({ status : "bind"});
    }), 1000)
  }
  render() {
    const { status, loginQr, qrStatus, openId } = this.state;
    var qrUrl = loginQr ? loginQr : "";
    // let openId = window.info.openId;
    // console.log(openId)
    return (
      <Modal
        className="bindModal"
        title={openId ? "解绑支付宝" : "绑定支付宝" }
        visible={ this.props.modalType === "bind" }
        onOk={ () => this.handleSubmit() }
        onCancel={ this.closeModal }
        okText="修改"
        footer={<Button onClick={ this.closeModal }>关闭</Button>}
      >
        {
          openId ?
          <div id="unBindDiv">
            <div  id="unBindContent">
              { status === "success" &&
                <div className="text-center">
                  <Icon className="bind-icon success" type="check-circle" />
                  <div className="mt-24">解绑成功</div>
                </div>
              }
              { status === "fail" &&
                <div className="text-center">
                  <Icon className="bind-icon fail" type="close-circle" />
                  <div className="mt-24">解绑失败</div>
                </div>
              }
              { status === "bind" && <div>
                  此账号已绑定支付宝账号，如需解除绑定请用绑定支付宝扫描二维码
                  <div id="unBindQr" className="text-center">
                    <QR size={200} value={ qrUrl }></QR>
                  </div>
                  { qrStatus === "EXPIRED" && <div className="qr-status">
                    <div style={{ marginTop : "20px" }}>二维码已过期</div>
                    <div><a onClick={ this.getBindQr }>点击刷新</a></div>
                    </div>
                  }
                  { qrStatus === "CHECKED" && <div className="qr-status success" onClick={ this.getBindQr }>
                      <div>扫码成功</div>
                    </div>
                  }
                </div>
              }
            </div>
          </div> :
          <div id="bindDiv">
            <div  id="bindContent">
              { status === "success" &&
                <div className="text-center">
                  <Icon className="bind-icon success" type="check-circle" />
                  <div className="mt-24">绑定成功</div>
                </div>
              }
              { status === "fail" &&
                <div className="text-center">
                  <Icon className="bind-icon fail" type="close-circle" />
                  <div className="mt-24">绑定失败</div>
                </div>
              }
              { status === "bind" && <div>
                  使用支付宝扫描二维码绑定账号，完成后可以使用支付宝扫码登录系统
                  <div id="bindQr" className="text-center">
                    <QR size={200} value={ qrUrl }></QR>
                  </div>
                  { qrStatus === "EXPIRED" && <div className="qr-status">
                    <div style={{ marginTop : "20px" }}>二维码已过期</div>
                    <div><a onClick={ this.getBindQr }>点击刷新</a></div>
                    </div>
                  }
                  { qrStatus === "CHECKED" && <div className="qr-status success" onClick={ this.getBindQr }>
                      <div>扫码成功</div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </Modal>
    );
  }
}

export default BindModal;



// WEBPACK FOOTER //
// ./src/index/bind/bindmodal.js